// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2TR2E","delete":"styles_delete__PZlEQ","update":"styles_update__3kIRB","add":"styles_add__3y1A4"};